import {
    FETCH_MY_PERMISSIONS,
    FETCH_MY_PERMISSIONS_SUCCESS,
    FETCH_MY_PERMISSIONS_FAILURE,
    CLEAR_PERMISSIONS,
} from './redux.actionTypes';

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_MY_PERMISSIONS:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_MY_PERMISSIONS_SUCCESS:
            return {
                ...state,
                data: payload,
                loading: false,
                error: null,
            };
        case FETCH_MY_PERMISSIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case CLEAR_PERMISSIONS:
            return initialState;
        default:
            return state;
    }
};
